var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M69.66 381.49a23.93 23.93 0 0 1-33.84 0l-22.65-22.7a24 24 0 0 1 0-33.94l154.04-154.31 56.89 56.78z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M435 358.75l-22.65 22.7a23.92 23.92 0 0 1-33.84 0l-211.34-211 40-40a23.93 23.93 0 0 1 33.84 0L435 324.81a24 24 0 0 1 0 33.94z","className":"fa-primary","key":2})]);
}

ChevronUp.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
